export default {
  namespaced: true,

  state() {
    return {
      primaryMenuIndex: 0,
      activeHierarchy: [],
      isMenuOpen: false,
      chevronActive: false,
      activeHierarchyIndex: [-1, -1, -1, -1],
    };
  },

  getters: {},
  mutations: {
    initialise: (state: any) => {
      if (localStorage.getItem("primaryMenuIndex")) {
        state.primaryMenuIndex = parseInt(
          localStorage.getItem("primaryMenuIndex") || "0",
        );
      }
      if (localStorage.getItem("activeHierarchy")) {
        state.activeHierarchy = JSON.parse(
          localStorage.getItem("activeHierarchy") || "[]",
        );
      }

      if (localStorage.getItem("activeHierarchyIndex")) {
        state.activeHierarchyIndex = JSON.parse(
          localStorage.getItem("activeHierarchyIndex") || "[]",
        );
      }

      if (localStorage.getItem("chevronActive")) {
        state.chevronActive =
          localStorage.getItem("chevronActive")?.toString() === "true";
      }

      if (localStorage.getItem("isMenuOpen")) {
        state.isMenuOpen =
          localStorage.getItem("isMenuOpen")?.toString() === "true";
      }
    },
    SET_PRIMARY_MENU_INDEX: (state: any, index: number) => {
      state.primaryMenuIndex = index;
      localStorage.setItem("primaryMenuIndex", index.toString());
    },
    SET_ACTIVE_HIERARCHY: (state: any, hierarchy: any) => {
      state.activeHierarchy = hierarchy;
      localStorage.setItem("activeHierarchy", JSON.stringify(hierarchy));
    },
    SET_ACTIVE_HIERARCHY_INDEX: (
      state: any,
      data: { level: number; index: number },
    ) => {
      state.activeHierarchyIndex[data.level] = data.index;
      localStorage.setItem(
        "activeHierarchyIndex",
        JSON.stringify(state.activeHierarchyIndex),
      );
    },
    SET_MENU_OPEN: (state: any, isOpen: boolean) => {
      state.isMenuOpen = isOpen;
      localStorage.setItem("isMenuOpen", isOpen.toString());
    },
    SET_CHEVRON_ACTIVE: (state: any, isActive: boolean) => {
      state.chevronActive = isActive;
      localStorage.setItem("chevronActive", isActive.toString());
    },
  },
  actions: {
    setPrimaryMenuIndex: ({ commit }, index: number) => {
      commit("SET_PRIMARY_MENU_INDEX", index);
    },
    setActiveHierarchy: ({ commit }, hierarchy: any) => {
      commit("SET_ACTIVE_HIERARCHY", hierarchy);
    },
    setActiveHierarchyIndex: (
      { commit },
      data: { level: number; index: number },
    ) => {
      commit("SET_ACTIVE_HIERARCHY_INDEX", data);
    },
    setMenuOpen: ({ commit }) => {
      commit("SET_MENU_OPEN", true);
    },
    setMenuClose: ({ commit }) => {
      commit("SET_MENU_OPEN", false);
    },
    setChevronActive: ({ commit }, isActive: boolean) => {
      commit("SET_CHEVRON_ACTIVE", isActive);
    },
    setChevronInactive: ({ commit }) => {
      commit("SET_CHEVRON_ACTIVE", false);
    },
  },
};
